/* eslint-disable no-nested-ternary */
import { Position } from '@xyflow/react';

// eslint-disable-next-line import/no-cycle
import { IPort, EPortType, EPortConnectionType } from './node-data';

export const generatePosition8P = (
  id: string,
  connectionTypes: EPortConnectionType[],
  portIds: string[],
  poePorts: boolean[],
): IPort[] => {
  const styles = [
    // top ports
    {
      left: '35%',
      // top: '16%'
    },
    {
      left: '49.4%',
      // top: '16%'
    },
    {
      left: '64%',
      // top: '16%'
    },
    {
      left: '79.6%',
      // top: '16%'
    },
    // bottom ports
    {
      left: '35%',
      // bottom: '16%'
    },
    {
      left: '49.4%',
      // bottom: '16%'
    },
    {
      left: '64%',
      // bottom: '16%'
    },
    {
      left: '79.6%',
      // bottom: '16%'
    },
  ];

  const posts: IPort[] = styles.map((style, index) => ({
    id: `${portIds[index]}`,
    type: [EPortType.SOURCE, EPortType.TARGET],
    connectionType: connectionTypes[index],
    position: index < 4 ? Position.Top : Position.Bottom,
    isPoE: poePorts[index],
    style,
  }));

  // posts.push({
  //   id: `${id}-9`,
  //   type: [EPortType.SOURCE, EPortType.TARGET],
  //   connectionType: EPortConnectionType.POWER,
  //   position: Position.Left,
  //   style: {
  //     // left: '28%',
  //     top: '50.5%',
  //   },
  // });

  return posts;
};

export const generatePosition10P = (
  id: string,
  connectionTypes: EPortConnectionType[],
  portIds: string[],
  poePorts: boolean[],
): IPort[] => {
  const styles = [
    // top ports
    {
      left: '20%',
      // top: '16%'
    },
    {
      left: '35%',
      // top: '16%'
    },
    {
      left: '49.4%',
      // top: '16%'
    },
    {
      left: '64%',
      // top: '16%'
    },
    {
      left: '79.6%',
      // top: '16%'
    },
    // bottom ports
    {
      left: '20%',
      // bottom: '16%'
    },
    {
      left: '35%',
      // bottom: '16%'
    },
    {
      left: '49.4%',
      // bottom: '16%'
    },
    {
      left: '64%',
      // bottom: '16%'
    },
    {
      left: '79.6%',
      // bottom: '16%'
    },
  ];

  const posts: IPort[] = styles.map((style, index) => ({
    id: `${portIds[index]}`,
    type: [EPortType.SOURCE, EPortType.TARGET],
    connectionType: connectionTypes[index],
    position: index < 5 ? Position.Top : Position.Bottom,
    isPoE: poePorts[index],
    style,
  }));

  // posts.push({
  //   id: `${id}-11`,
  //   type: [EPortType.SOURCE, EPortType.TARGET],
  //   connectionType: EPortConnectionType.POWER,
  //   position: Position.Left,
  //   style: {
  //     left: '27.5%',
  //     // top: '50.5%',
  //   },
  // });

  return posts;
};

export const generatePosition16P = (
  id: string,
  connectionTypes: EPortConnectionType[],
  portIds: string[],
  poePorts: boolean[],
): IPort[] => {
  const styles = [
    // top ports
    {
      left: '15%',
      // top: '15%'
    },
    {
      left: '27.5%',
      // top: '15%'
    },
    {
      left: '39.5%',
      // top: '15%'
    },
    {
      left: '51.2%',
      // top: '15%'
    },
    {
      left: '63.5%',
      // top: '15%'
    },
    {
      left: '75.5%',
      // top: '15%'
    },
    {
      top: '15%',
      // right: '13%'
    },
    {
      top: '37%',
      // right: '13%'
    },
    {
      top: '62%',
      // right: '13%'
    },
    {
      top: '85%',
      // right: '13%',
    },

    // bottom ports
    {
      left: '15%',
      // bottom: '15%'
    },
    {
      left: '27.5%',
      // bottom: '15%'
    },
    {
      left: '39.5%',
      // bottom: '15%'
    },
    {
      left: '51.2%',
      // bottom: '15%'
    },
    {
      left: '63.5%',
      // bottom: '15%'
    },
    {
      left: '75.5%',
      // bottom: '15%'
    },
  ];

  const posts: IPort[] = styles.map((style, index) => ({
    id: `${portIds[index]}`,
    type: [EPortType.SOURCE, EPortType.TARGET],
    connectionType: connectionTypes[index],
    position:
      index < 6 ? Position.Top : index < 10 ? Position.Right : Position.Bottom,
    style,
    isPoE: poePorts[index],
  }));

  // posts.push({
  //   id: `${id}-17`,
  //   type: [EPortType.SOURCE, EPortType.TARGET],
  //   connectionType: EPortConnectionType.POWER,
  //   position: Position.Bottom,
  //   style: {
  //     left: '21.5%',
  //     top: '43%',
  //   },
  // });

  // posts.push({
  //   id: `${id}-18`,
  //   type: [EPortType.SOURCE, EPortType.TARGET],
  //   connectionType: EPortConnectionType.USB,
  //   position: Position.Bottom,
  //   style: {
  //     left: '34%',
  //     top: '43%',
  //   },
  // });

  return posts;
};

export const generatePosition24P = (
  id: string,
  connectionTypes: EPortConnectionType[],
  portIds: string[],
  poePorts: boolean[],
): IPort[] => {
  const styles = [
    // top ports
    {
      left: '9.5%',
      // top: '10%'
    },
    {
      left: '17.5%',
      // top: '10%'
    },
    {
      left: '25.5%',
      // top: '10%'
    },
    {
      left: '33.5%',
      // top: '10%'
    },
    {
      left: '41.5%',
      // top: '10%'
    },
    {
      left: '49.5%',
      // top: '10%'
    },
    {
      left: '57.5%',
      // top: '10%'
    },
    {
      left: '65.5%',
      // top: '10%'
    },
    {
      left: '73.5%',
      // top: '10%'
    },
    {
      left: '81.5%',
      // top: '10%'
    },
    // bottom ports
    {
      left: '9.5%',
      // bottom: '10%'
    },
    {
      left: '17.5%',
      // bottom: '10%'
    },
    {
      left: '25.5%',
      // bottom: '10%'
    },
    {
      left: '33.5%',
      // bottom: '10%'
    },
    {
      left: '41.5%',
      // bottom: '10%'
    },
    {
      left: '49.5%',
      // bottom: '10%'
    },
    {
      left: '57.5%',
      // bottom: '10%'
    },
    {
      left: '65.5%',
      // bottom: '10%'
    },
    {
      left: '73.5%',
      // bottom: '10%'
    },
    {
      left: '81.5%',
      // bottom: '10%'
    },
    // right ports
    {
      top: '14%',
      // right: '10%'
    },
    {
      top: '37%',
      // right: '10%'
    },
    {
      top: '63%',
      // right: '10%'
    },
    {
      top: '86%',
      // right: '10%'
    },
  ];
  const posts: IPort[] = styles.map((style, index) => ({
    id: `${portIds[index]}`,
    type: [EPortType.SOURCE, EPortType.TARGET],
    connectionType: connectionTypes[index],
    position:
      index < 10 ? Position.Top : index < 20 ? Position.Bottom : Position.Right,
    isPoE: poePorts[index],
    style,
  }));

  return posts;
};
